export default {
    groupName: 'square',
    appName: 'Square',
    baseRoute: '/dashboard/square',
    label: 'Square Ad Dashboard',
    home: '/slicer',
    image: 'square.png',
    description: 'Square Global Ad Dashboard'
}